import React, { PureComponent } from 'react'
import T from 'prop-types'
import IT from 'react-immutable-proptypes'
import {
  FileUploadReader,
  DialogContainer
} from 'react-base'
import {
  fromJS,
  Map,
  List,
} from 'immutable'
import papaParse from 'papaparse'
import ColumnMapper from '../column-mapper/ColumnMapper'
import {
  SCHEMA_SHAPE
} from '../shapes'
import {
  pluralize
} from 'pw-formatters'

const SUPPORTED_READER_FILE_TYPES = [
  'csv'
]

export default class FileReader extends PureComponent {
  static displayName = 'Schemer.FileReader'

  static propTypes = {
    className: T.string,
    onSave: T.func,
    schema: SCHEMA_SHAPE,
    acceptTypes: IT.listOf(T.oneOf(SUPPORTED_READER_FILE_TYPES)),
    openOnMount: T.bool
  }

  static defaultProps = {
    acceptTypes: List(['csv']),
    openOnMount: false
  }

  state = {
    parsedFiles: null
  }

  parseFile = fileText => {
    const parsed = papaParse.parse(fileText, {
      dynamicTyping: true,
      skipEmptyLines: true
    })

    return parsed.data
  }

  handleFileData = (fileData = {}) => {
    this.setState({
      parsedFiles: fromJS(fileData)
    })
  }

  handleMapperSave = (mappedOutput) => {
    const {
      schema,
      onSave
    } = this.props
    const isValidFilter = rowValidation => rowValidation.get('isValid')

    const output = mappedOutput.reduce((out, items, fileName) => {
      const itemValidation = schema.validateAll(items)

      return out.set(fileName, Map({
        valid: itemValidation.filter(isValidFilter),
        invalid: itemValidation.filterNot(isValidFilter),
      }))
    }, Map())

    onSave(output)
    this.resetFiles()
  }

  resetFiles = () => {
    this.setState({
      parsedFiles: null
    })
  }

  renderUploadButton = () => {
    const {
      openOnMount
    } = this.props
    const {
      parsedFiles
    } = this.state
    return (
      <div className="schemer_file_reader_input_wrap">
        <FileUploadReader
          allowedFileExtensions={['csv', 'txt']}
          className="schemer_file_reader_input"
          fileParser={this.parseFile}
          onChange={this.handleFileData}
          openOnMount={openOnMount}
          simpleLoadingIndicator={parsedFiles != null}
        >{parsedFiles ? 'Select New' : 'Upload'} CSV Files...</FileUploadReader>
      </div>
    )
  }

  render() {
    const  {
      schema
    } = this.props
    const {
      parsedFiles
    } = this.state

    const numFiles = parsedFiles ? parsedFiles.size : 0
    const hasFiles = numFiles > 0

    return (
      <div className={`schemer_file_reader ${hasFiles ? 'has_files' : ''}`}>
        {hasFiles ? (
          <DialogContainer
            modal
            onMaskClick={this.resetFiles}
          >
            <div className={ `modal_dialog schemer_file_reader_dialog ${hasFiles ? 'has_files' : ''}` }>
              <span
                className="remove_btn"
                onClick={this.resetFiles}
              />
              <header>
                <h1>Import {numFiles} CSV {pluralize(numFiles, 'File')}</h1>
                {this.renderUploadButton()}
              </header>
              <section>
                <ColumnMapper
                  schema={schema}
                  files={parsedFiles}
                  onSave={this.handleMapperSave}
                  onCancel={this.resetFiles}
                />
              </section>
            </div>
          </DialogContainer>
        ) : (
          this.renderUploadButton()
        )}
      </div>
    )
  }
}